import React from 'react';
import { useTranslation } from 'react-i18next';
import GoldBanner from '../../../images/plan_gold.svg';

const GoldCard = () => {
  const { t } = useTranslation();
  return(
    <div>
      <div
        id='goldCard'
        className='border cursor-pointer rounded-lg  hover:scale-105 hover:ease-out duration-300 pt-4 w-full leading-4 bg-black scale-105'
      >
        <div className='pl-5'>
          <div className=''>
            <p
              id='first'
              className='text-[28px] font-serif text-white'
            >
              {' '}
              {t('listingItem.goldPlan')}
            </p>
            <p
              id='first'
              className='text-[9px] text-white'
            >
              {t('listingItem.goldHead')}
            </p>
          </div>
          <div
            className='block sm:flex sm:space-x-7 leading-4 text-white'
          >
            <div className='pt-4 sm:pt-8 flex'>
              <svg
                id='second'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 512 512'
                className='h-6 w-6'
                fill='red'
              >
                <path d='M447.1 32h-384C28.64 32-.0091 60.65-.0091 96v320c0 35.35 28.65 64 63.1 64h384c35.35 0 64-28.65 64-64V96C511.1 60.65 483.3 32 447.1 32zM111.1 96c26.51 0 48 21.49 48 48S138.5 192 111.1 192s-48-21.49-48-48S85.48 96 111.1 96zM446.1 407.6C443.3 412.8 437.9 416 432 416H82.01c-6.021 0-11.53-3.379-14.26-8.75c-2.73-5.367-2.215-11.81 1.334-16.68l70-96C142.1 290.4 146.9 288 152 288s9.916 2.441 12.93 6.574l32.46 44.51l93.3-139.1C293.7 194.7 298.7 192 304 192s10.35 2.672 13.31 7.125l128 192C448.6 396 448.9 402.3 446.1 407.6z' />
              </svg>
              <span id='first' className='text-[14px] pl-4'>
                10 {t('listingItem.pictures')} / videos
              </span>
            </div>
            <div
              className='pt-4 sm:pt-8 flex leading-4 text-white'
            >
              <svg
                id='second'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 384 512'
                className='w-6 h-6'
                fill='red'
              >
                <path d='M88 304H80V256H88C101.3 256 112 266.7 112 280C112 293.3 101.3 304 88 304zM192 256H200C208.8 256 216 263.2 216 272V336C216 344.8 208.8 352 200 352H192V256zM224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM64 224C55.16 224 48 231.2 48 240V368C48 376.8 55.16 384 64 384C72.84 384 80 376.8 80 368V336H88C118.9 336 144 310.9 144 280C144 249.1 118.9 224 88 224H64zM160 368C160 376.8 167.2 384 176 384H200C226.5 384 248 362.5 248 336V272C248 245.5 226.5 224 200 224H176C167.2 224 160 231.2 160 240V368zM288 224C279.2 224 272 231.2 272 240V368C272 376.8 279.2 384 288 384C296.8 384 304 376.8 304 368V320H336C344.8 320 352 312.8 352 304C352 295.2 344.8 288 336 288H304V256H336C344.8 256 352 248.8 352 240C352 231.2 344.8 224 336 224H288zM256 0L384 128H256V0z' />
              </svg>
              <span id='first' className='text-[14px] pl-4'>
                2 PDF
              </span>
            </div>
          </div>
          <div className='flex justify-between'>
            <div
              className='block sm:flex sm:space-x-8 leading-4 text-white'
            >
              <div className='flex pt-4 sm:pt-8'>
                <svg
                  id='second'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 448 512'
                  className='w-6 h-6'
                  fill='red'
                >
                  <path d='M160 80C160 53.49 181.5 32 208 32H240C266.5 32 288 53.49 288 80V432C288 458.5 266.5 480 240 480H208C181.5 480 160 458.5 160 432V80zM0 272C0 245.5 21.49 224 48 224H80C106.5 224 128 245.5 128 272V432C128 458.5 106.5 480 80 480H48C21.49 480 0 458.5 0 432V272zM400 96C426.5 96 448 117.5 448 144V432C448 458.5 426.5 480 400 480H368C341.5 480 320 458.5 320 432V144C320 117.5 341.5 96 368 96H400z' />
                </svg>
                <span id='first' className='text-[14px] pl-4'>
                  {t('listingItem.ad_statistic')}
                </span>
              </div>
              <div className='flex pt-4 sm:pt-8'>
                <svg
                  id='second'
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 512 512'
                  className='w-6 h-6'
                  fill='red'
                >
                  <path d='M64 400C64 408.8 71.16 416 80 416H480C497.7 416 512 430.3 512 448C512 465.7 497.7 480 480 480H80C35.82 480 0 444.2 0 400V64C0 46.33 14.33 32 32 32C49.67 32 64 46.33 64 64V400zM342.6 278.6C330.1 291.1 309.9 291.1 297.4 278.6L240 221.3L150.6 310.6C138.1 323.1 117.9 323.1 105.4 310.6C92.88 298.1 92.88 277.9 105.4 265.4L217.4 153.4C229.9 140.9 250.1 140.9 262.6 153.4L320 210.7L425.4 105.4C437.9 92.88 458.1 92.88 470.6 105.4C483.1 117.9 483.1 138.1 470.6 150.6L342.6 278.6z' />
                </svg>
                <span id='first' className='text-[14px] pl-4'>
                  {t('listingItem.top_listing')}
                </span>
              </div>
            </div>
            <div className='float-right rounded-br-lg'>
              <img src={GoldBanner} alt='' className='rounded-br-lg' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { GoldCard, };
